import * as LoginModule from "../Pages/Auth/Login";
import * as ForgotPasswordPageModule from "../Pages/Auth/ForgotPasswordPage";
import * as InviteAcceptPageModule from "../Pages/Auth/InviteAcceptPage";
import * as CompanyAdminPageModule from "../Pages/Admin/CompanyAdminPage";
import * as CompanyBankAccountPageModule from "../Pages/Admin/CompanyBankAccountPage";
import * as InviteCreatePageModule from "../Pages/Admin/InviteCreatePage";
import * as InvitesListPageModule from "../Pages/Admin/InvitesListPage";
import * as RoleAdminPageModule from "../Pages/Admin/RoleAdminPage";
import * as UsersAdminPageModule from "../Pages/Admin/UsersAdminPage";
import * as PermissionGuidePageModule from "../Pages/Admin/PermissionGuidePage";
import * as CashSessionAdminPageModule from "../Pages/Admin/CashSessionAdminPage";
import * as SalesConfigPageModule from "../Pages/Admin/SalesConfigPage";
import * as CountSettingsPageModule from "../Pages/Admin/CountSettingsPage";
import * as ProductsListPageModule from "../Pages/Products/ProductsListPage";
import * as CreateProductPageModule from "../Pages/Products/CreateProduct";
import * as CategoriesPageModule from "../Pages/Settings/CategoriesPage";
import * as BrandsPageModule from "../Pages/Settings/BrandsPage";
import * as FamiliesPageModule from "../Pages/Settings/FamiliesPage";
import * as FormatsPageModule from "../Pages/Settings/FormatsPage";
import * as CashSessionCajeroPageModule from "../Pages/Cash/CashSessionCajeroPage";
import * as CashRegistersPageModule from "../Pages/Cash/CashRegistersPage";
import * as CashboxPageModule from "../Pages/Cashbox/CashboxPage";
import * as ProfilePageModule from "../Pages/Profile/ProfilePage";
import * as SalesPageModule from "../Pages/Sales/SalesPage";
import * as SalesHistoryPageModule from "../Pages/Sales/SalesHistoryPage";
import * as InvoiceDocumentsPageModule from "../Pages/Invoice/InvoiceDocumentsPage";
import * as InvoicePendingPageModule from "../Pages/Invoice/InvoicePendingPage";
import * as GroomingReceptionPageModule from "../Pages/Grooming/GroomingReceptionPage";
import * as GroomingOrdersPageModule from "../Pages/Grooming/GroomingOrdersPage";
import * as GroomingAppointmentsPageModule from "../Pages/Grooming/GroomingAppointmentsPage";
import * as GroomingOrderDetailPageModule from "../Pages/Grooming/GroomingOrderDetailPage";
import * as GroomingServiceTypesPageModule from "../Pages/Grooming/GroomingServiceTypesPage";
import * as GroomingConfigPageModule from "../Pages/Grooming/GroomingConfigPage";
import * as CustomersListPageModule from "../Pages/Customers/CustomersListPage";
import * as CustomerCreatePageModule from "../Pages/Customers/CustomerCreatePage";
import * as ProductUtilityReportPageModule from "../Pages/Reports/ProductUtilityReportPage";
import * as SalesProfitReportPageModule from "../Pages/Reports/SalesProfitReportPage";
import * as SalesByDateReportPageModule from "../Pages/Reports/SalesByDateReportPage";
import * as InboundNotesPageModule from "../Pages/Inventory/InboundNotesPage";
import * as CreateInboundNotePageModule from "../Pages/Inventory/CreateInboundNotePage";
import * as OutboundNotesPageModule from "../Pages/Inventory/OutboundNotesPage";
import * as CreateOutboundNotePageModule from "../Pages/Inventory/CreateOutboundNotePage";
import * as StocksPageModule from "../Pages/Inventory/StocksPage";
import * as StockCountSelectivePageModule from "../Pages/Inventory/StockCountSelectivePage";
import * as StockCountGeneralPageModule from "../Pages/Inventory/StockCountGeneralPage";
import * as StockCountReviewPageModule from "../Pages/Inventory/StockCountReviewPage";
import * as StockMovementsPageModule from "../Pages/Inventory/StockMovementsPage";
import { Navigate } from "react-router-dom";
import {
  AccountBalanceOutlined,
  ApartmentOutlined,
  CategoryOutlined,
  HomeOutlined,
  HistoryOutlined,
  Inventory2Outlined,
  InventoryOutlined,
  LinkOutlined,
  LocalOfferOutlined,
  LocalShippingOutlined,
  ManageAccountsOutlined,
  MiscellaneousServicesOutlined,
  PointOfSaleOutlined,
  AccountCircleOutlined,
  AssessmentOutlined,
  PeopleOutlined,
  PersonAddAlt1Outlined,
  PetsOutlined,
  PrecisionManufacturingOutlined,
  SecurityOutlined,
  SellOutlined,
  SettingsSuggestOutlined,
  ShieldOutlined,
  TimelineOutlined,
  DriveFileMove,
  ContentCutOutlined,
  EventOutlined,
  PlaylistAddCheckOutlined,
  ReceiptLongOutlined,
} from "@mui/icons-material";
import HomePage from "../Pages/Home";
import {
  GENERAL_INVENTORY_PERMISSIONS,
  SELECTIVE_INVENTORY_PERMISSIONS,
} from "../config/permissionUtils";

const LoginPage = LoginModule.default;
const ForgotPasswordPage = ForgotPasswordPageModule.default;
const InviteAcceptPage = InviteAcceptPageModule.default;
const CompanyAdminPage = CompanyAdminPageModule.default;
const CompanyBankAccountPage = CompanyBankAccountPageModule.default;
const InviteCreatePage = InviteCreatePageModule.default;
const InvitesListPage = InvitesListPageModule.default;
const RoleAdminPage = RoleAdminPageModule.default;
const UsersAdminPage = UsersAdminPageModule.default;
const PermissionGuidePage = PermissionGuidePageModule.default;
const CashSessionAdminPage = CashSessionAdminPageModule.default;
const SalesConfigPage = SalesConfigPageModule.default;
const CountSettingsPage = CountSettingsPageModule.default;
const ProductsListPage = ProductsListPageModule.default;
const CreateProductPage = CreateProductPageModule.default;
const CategoriesPage = CategoriesPageModule.default;
const BrandsPage = BrandsPageModule.default;
const FamiliesPage = FamiliesPageModule.default;
const FormatsPage = FormatsPageModule.default;
const CashSessionCajeroPage = CashSessionCajeroPageModule.default;
const CashRegistersPage = CashRegistersPageModule.default;
const CashboxPage = CashboxPageModule.default;
const ProfilePage = ProfilePageModule.default;
const SalesPage = SalesPageModule.default;
const SalesHistoryPage = SalesHistoryPageModule.default;
const InvoiceDocumentsPage = InvoiceDocumentsPageModule.default;
const InvoicePendingPage = InvoicePendingPageModule.default;
const GroomingReceptionPage = GroomingReceptionPageModule.default;
const GroomingOrdersPage = GroomingOrdersPageModule.default;
const GroomingAppointmentsPage = GroomingAppointmentsPageModule.default;
const GroomingOrderDetailPage = GroomingOrderDetailPageModule.default;
const GroomingServiceTypesPage = GroomingServiceTypesPageModule.default;
const GroomingConfigPage = GroomingConfigPageModule.default;
const CustomersListPage = CustomersListPageModule.default;
const CustomerCreatePage = CustomerCreatePageModule.default;
const ProductUtilityReportPage = ProductUtilityReportPageModule.default;
const SalesProfitReportPage = SalesProfitReportPageModule.default;
const SalesByDateReportPage = SalesByDateReportPageModule.default;
const InboundNotesPage = InboundNotesPageModule.default;
const CreateInboundNotePage = CreateInboundNotePageModule.default;
const OutboundNotesPage = OutboundNotesPageModule.default;
const CreateOutboundNotePage = CreateOutboundNotePageModule.default;
const StocksPage = StocksPageModule.default;
const StockCountSelectivePage = StockCountSelectivePageModule.default;
const StockCountGeneralPage = StockCountGeneralPageModule.default;
const StockCountReviewPage = StockCountReviewPageModule.default;
const StockMovementsPage = StockMovementsPageModule.default;

const loginElement = LoginPage ? <LoginPage /> : <div>Login TODO</div>;
const forgotPasswordElement = ForgotPasswordPage ? <ForgotPasswordPage /> : <div>Recuperar contraseña TODO</div>;
const inviteElement = InviteAcceptPage ? <InviteAcceptPage /> : <div>Aceptar invitacion TODO</div>;
const companiesElement = CompanyAdminPage ? <CompanyAdminPage /> : <div>Empresas TODO</div>;
const companyBankAccountsElement = CompanyBankAccountPage ? <CompanyBankAccountPage /> : <div>Cuentas bancarias TODO</div>;
const invitesElement = InvitesListPage ? <InvitesListPage /> : <div>Invitaciones TODO</div>;
const inviteCreateElement = InviteCreatePage ? <InviteCreatePage /> : <div>Crear invitacion TODO</div>;
const rolesElement = RoleAdminPage ? <RoleAdminPage /> : <div>Roles TODO</div>;
const usersElement = UsersAdminPage ? <UsersAdminPage /> : <div>Usuarios TODO</div>;
const adminCashSessionsElement = CashSessionAdminPage ? <CashSessionAdminPage /> : <div>Cuadres de caja TODO</div>;
const salesConfigElement = SalesConfigPage ? <SalesConfigPage /> : <div>Configuracion de ventas TODO</div>;
const countSettingsElement = CountSettingsPage ? <CountSettingsPage /> : <div>Ajustes de conteo TODO</div>;
const cashierCashSessionElement = CashSessionCajeroPage ? <CashSessionCajeroPage /> : <div>Mi caja TODO</div>;
const permissionsElement = PermissionGuidePage ? <PermissionGuidePage /> : <div>Guia de permisos TODO</div>;
const productsElement = ProductsListPage ? <ProductsListPage /> : <div>Productos TODO</div>;
const createProductElement = CreateProductPage ? <CreateProductPage /> : <div>Crear producto TODO</div>;
const categoriesElement = CategoriesPage ? <CategoriesPage /> : <div>Categorias TODO</div>;
const brandsElement = BrandsPage ? <BrandsPage /> : <div>Marcas TODO</div>;
const familiesElement = FamiliesPage ? <FamiliesPage /> : <div>Familias TODO</div>;
const formatsElement = FormatsPage ? <FormatsPage /> : <div>Formatos TODO</div>;
const cashRegistersElement = CashRegistersPage ? <CashRegistersPage /> : <div>Cajas TODO</div>;
const cashboxElement = CashboxPage ? <CashboxPage /> : <div>TODO Caja: ventas pendientes</div>;
const profileElement = ProfilePage ? <ProfilePage /> : <div>Perfil TODO</div>;
const salesElement = SalesPage ? <SalesPage /> : <div>Ventas TODO</div>;
const salesHistoryElement = SalesHistoryPage ? <SalesHistoryPage /> : <div>Historial ventas TODO</div>;
const invoiceDocumentsElement = InvoiceDocumentsPage ? <InvoiceDocumentsPage /> : <div>Facturas internas TODO</div>;
const invoicePendingElement = InvoicePendingPage ? <InvoicePendingPage /> : <div>Pendientes de facturacion TODO</div>;
const groomingReceptionElement = GroomingReceptionPage ? <GroomingReceptionPage /> : <div>Recepcion grooming TODO</div>;
const groomingOrdersElement = GroomingOrdersPage ? <GroomingOrdersPage /> : <div>Ordenes grooming TODO</div>;
const groomingAppointmentsElement = GroomingAppointmentsPage ? <GroomingAppointmentsPage /> : <div>Citas grooming TODO</div>;
const groomingOrderDetailElement = GroomingOrderDetailPage ? <GroomingOrderDetailPage /> : <div>Detalle grooming TODO</div>;
const groomingServiceTypesElement = GroomingServiceTypesPage ? <GroomingServiceTypesPage /> : <div>Tipos servicio grooming TODO</div>;
const groomingConfigElement = GroomingConfigPage ? <GroomingConfigPage /> : <div>Configuracion grooming TODO</div>;
const customersElement = CustomersListPage ? <CustomersListPage /> : <div>Clientes TODO</div>;
const customerCreateElement = CustomerCreatePage ? <CustomerCreatePage /> : <div>Nuevo cliente TODO</div>;
const productUtilityReportElement = ProductUtilityReportPage ? <ProductUtilityReportPage /> : <div>Reporte productos TODO</div>;
const salesProfitReportElement = SalesProfitReportPage ? <SalesProfitReportPage /> : <div>Reporte utilidad ventas TODO</div>;
const salesByDateReportElement = SalesByDateReportPage ? <SalesByDateReportPage /> : <div>Reporte ventas por fecha TODO</div>;
const inboundNotesElement = InboundNotesPage ? <InboundNotesPage /> : <div>Notas de entrada TODO</div>;
const createInboundNoteElement = CreateInboundNotePage ? <CreateInboundNotePage /> : <div>Nueva nota entrada TODO</div>;
const outboundNotesElement = OutboundNotesPage ? <OutboundNotesPage /> : <div>Notas de salida TODO</div>;
const createOutboundNoteElement = CreateOutboundNotePage ? <CreateOutboundNotePage /> : <div>Nueva nota salida TODO</div>;
const stocksElement = StocksPage ? <StocksPage /> : <div>Existencias TODO</div>;
const stockCountSelectiveElement = StockCountSelectivePage ? <StockCountSelectivePage /> : <div>Conteo selectivo TODO</div>;
const stockCountGeneralElement = StockCountGeneralPage ? <StockCountGeneralPage /> : <div>Conteo general TODO</div>;
const stockCountReviewElement = StockCountReviewPage ? <StockCountReviewPage /> : <div>Revision de conteo TODO</div>;
const stockMovementsElement = StockMovementsPage ? <StockMovementsPage /> : <div>Movimientos inventario TODO</div>;

export const publicRoutes = [
  {
    path: "/login",
    element: loginElement,
  },
  {
    path: "/forgot-password",
    element: forgotPasswordElement,
    redirectIfAuthenticated: false,
  },
  {
    path: "/invite/accept",
    element: inviteElement,
    redirectIfAuthenticated: false,
  },
  {
    path: "/invite/:token",
    element: inviteElement,
    redirectIfAuthenticated: false,
  },
];

export const privateRoutes = [
  {
    path: "/",
    nav: true,
    label: "Inicio",
    icon: <HomeOutlined fontSize="small" />,
    element: <HomePage /> ,
  },
  {
    path: "/home",
    nav: false,
    element: <HomePage />,
  },
  {
    path: "/admin/companies",
    element: companiesElement,
    superuserOnly: true,
  },
  {
    path: "/admin/roles",
    element: rolesElement,
    requiredAnyPerms: ["view_roles", "manage_roles"],
  },
  {
    path: "/admin/company-bank-accounts",
    label: "Cuentas bancarias",
    element: companyBankAccountsElement,
    requiredAnyPerms: ["sale_manage_transfer_accounts"],
  },
  {
    path: "/admin/users",
    element: usersElement,
    requiredAnyPerms: ["view_users", "manage_users"],
  },
  {
    path: "/admin/invites",
    label: "Invitaciones",
    element: invitesElement,
    requiredAnyPerms: ["manage_users"],
  },
  {
    path: "/admin/invites/create",
    nav: false,
    label: "Generar invitacion",
    element: inviteCreateElement,
    requiredAnyPerms: ["manage_users"],
  },
  {
    path: "/admin/permissions",
    element: permissionsElement,
    requiredAnyPerms: ["view_permissions", "manage_permissions"],
  },
  {
    path: "/admin/cash",
    label: "Cuadres de caja",
    element: adminCashSessionsElement,
    requiredAnyPerms: ["cash_session_view", "cash_session_manage"],
  },
  {
    path: "/settings/sales",
    label: "Configuracion de ventas",
    element: salesConfigElement,
    requiredAnyPerms: ["manage_sales", "sale_manage_transfer_accounts", "cash_session_manage", "billing_manage"],
  },
  {
    path: "/admin/count-settings",
    label: "Ajustes de conteo",
    element: countSettingsElement,
    requiredAnyPerms: ["inventory_count_settings_manage"],
  },
  {
    path: "/admin/cash-sessions",
    nav: false,
    element: <Navigate to="/admin/cash" replace />,
    sidebar: false,
  },
  {
    path: "/products",
    element: productsElement,
    requiredAnyPerms: ["view_products", "manage_products"],
  },
  {
    path: "/products/create",
    element: createProductElement,
    requiredAnyPerms: ["manage_products"],
  },
  {
    path: "/sales",
    nav: false,
    label: "Venta Normal",
    icon: <SellOutlined fontSize="small" />,
    element: salesElement,
    requiredAnyPerms: ["sale_create"],
  },
  {
    path: "/sales/create",
    nav: false,
    label: "Ventas",
    element: <Navigate to="/sales" replace />,
  },
  {
    path: "/sales/history",
    nav: false,
    label: "Historial de ventas",
    element: salesHistoryElement,
    requiredAnyPerms: ["view_sales", "sale_void", "sales_return_view", "sales_return_create"],
  },
  {
    path: "/invoice/pending",
    nav: false,
    label: "Pendientes de facturacion",
    element: invoicePendingElement,
    requiredAnyPerms: ["billing_deferred_view", "billing_deferred_create"],
    requiresBilling: true,
    requiresDeferredBilling: true,
  },
  {
    path: "/invoice/documents",
    nav: false,
    label: "Facturas internas",
    element: invoiceDocumentsElement,
    requiredAnyPerms: ["billing_view", "billing_create", "billing_manage"],
    requiresBilling: true,
  },
  {
    path: "/grooming/reception",
    nav: false,
    label: "Recepcion grooming",
    element: groomingReceptionElement,
    requiredAnyPerms: ["grooming_view"],
  },
  {
    path: "/grooming/orders",
    nav: false,
    label: "Ordenes grooming",
    element: groomingOrdersElement,
    requiredAnyPerms: ["grooming_view"],
  },
  {
    path: "/grooming/orders/:orderId",
    nav: false,
    label: "Detalle grooming",
    element: groomingOrderDetailElement,
    requiredAnyPerms: ["grooming_view"],
  },
  {
    path: "/grooming/appointments",
    nav: false,
    label: "Agenda grooming",
    element: groomingAppointmentsElement,
    requiredAnyPerms: ["grooming_view"],
  },
  {
    path: "/grooming/service-types",
    nav: false,
    label: "Tipos servicio grooming",
    element: groomingServiceTypesElement,
    requiredAnyPerms: ["grooming_settings_manage"],
  },
  {
    path: "/grooming/config",
    nav: false,
    label: "Configuracion grooming",
    element: groomingConfigElement,
    requiredAnyPerms: ["grooming_settings_manage"],
  },
  {
    path: "/customers",
    nav: false,
    label: "Clientes",
    element: customersElement,
    requiredAnyPerms: ["sale_create", "view_sales"],
  },
  {
    path: "/customers/create",
    nav: false,
    label: "Nuevo cliente",
    element: customerCreateElement,
    requiredAnyPerms: ["sale_create"],
  },
  {
    path: "/customers/:customerId/edit",
    nav: false,
    label: "Editar cliente",
    element: customerCreateElement,
    requiredAnyPerms: ["sale_create"],
  },
  {
    path: "/reports/products-profit",
    nav: false,
    label: "Reporte por producto y su utilidad",
    element: productUtilityReportElement,
    requiredAnyPerms: ["view_reports"],
  },
  {
    path: "/reports/sales-profit",
    nav: false,
    label: "Reporte de utilidad ventas general",
    element: salesProfitReportElement,
    requiredAnyPerms: ["view_reports"],
  },
  {
    path: "/reports/sales-by-date",
    nav: false,
    label: "Ventas agrupadas por fecha",
    element: salesByDateReportElement,
    requiredAnyPerms: ["view_reports"],
  },
  {
    path: "/cashbox",
    nav: false,
    label: "Caja",
    icon: <PointOfSaleOutlined fontSize="small" />,
    element: cashboxElement,
    requiredPerms: ["cash_view"],
    requiresCashierQueue: true,
  },
  {
    path: "/settings/categories",
    element: categoriesElement,
    requiredAnyPerms: ["view_categories", "manage_categories"],
  },
  {
    path: "/settings/brands",
    element: brandsElement,
    requiredAnyPerms: ["view_brands", "manage_brands"],
  },
  {
    path: "/settings/families",
    element: familiesElement,
    requiredAnyPerms: ["view_families", "manage_families"],
  },
  {
    path: "/settings/formats",
    element: formatsElement,
    requiredAnyPerms: ["view_formats", "manage_formats"],
  },
  {
    path: "/settings/cash-register",
    nav: false,
    label: "Caja fisica",
    element: cashRegistersElement,
    requiredAnyPerms: ["cash_register_view", "cash_register_manage"],
  },
  {
    path: "/inventory/inbound-notes",
    nav: false,
    label: "Notas de entrada",
    element: inboundNotesElement,
    requiredAnyPerms: ["inventory_inbound_view", "inventory_inbound_create"],
  },
  {
    path: "/inventory/inbound/create",
    nav: false,
    label: "Nueva nota de entrada",
    element: createInboundNoteElement,
    requiredAnyPerms: ["inventory_inbound_create"],
  },
  {
    path: "/inventory/outbound-notes",
    nav: false,
    label: "Notas de salida",
    element: outboundNotesElement,
    requiredAnyPerms: ["inventory_outbound_view", "inventory_outbound_create", "inventory_outbound_approve"],
  },
  {
    path: "/inventory/outbound/create",
    nav: false,
    label: "Nueva nota de salida",
    element: createOutboundNoteElement,
    requiredAnyPerms: ["inventory_outbound_create"],
  },
  {
    path: "/inventory/stocks",
    nav: false,
    label: "Existencias",
    element: stocksElement,
    requiredAnyPerms: ["inventory_stock_view"],
  },
  {
    path: "/inventory/counts/selective",
    nav: false,
    label: "Selectivos",
    element: stockCountSelectiveElement,
    requiredAnyPerms: SELECTIVE_INVENTORY_PERMISSIONS,
  },
  {
    path: "/inventory/counts/selective/new",
    nav: false,
    label: "Nuevo conteo selectivo",
    element: stockCountSelectiveElement,
    requiredAnyPerms: SELECTIVE_INVENTORY_PERMISSIONS,
  },
  {
    path: "/inventory/counts/general",
    nav: false,
    label: "Inventario general",
    element: stockCountGeneralElement,
    requiredAnyPerms: GENERAL_INVENTORY_PERMISSIONS,
  },
  {
    path: "/inventory/counts/general/new",
    nav: false,
    label: "Nuevo inventario general",
    element: stockCountGeneralElement,
    requiredAnyPerms: GENERAL_INVENTORY_PERMISSIONS,
  },
  {
    path: "/inventory/counts/general/capture",
    nav: false,
    label: "Captura de inventario general",
    element: stockCountGeneralElement,
    requiredAnyPerms: GENERAL_INVENTORY_PERMISSIONS,
  },
  {
    path: "/inventory/counts/:id/review",
    nav: false,
    label: "Revision de conteo",
    element: stockCountReviewElement,
    requiredAnyPerms: [
      "inventory_selective_view",
      "inventory_selective_review",
      "inventory_selective_count",
      "inventory_selective_adjust",
      "inventory_selective_cross",
      "inventory_selective_apply",
      "inventory_selective_cancel",
      "inventory_general_view",
      "inventory_general_review",
      "inventory_general_count",
      "inventory_general_adjust",
      "inventory_general_cross",
      "inventory_general_apply",
      "inventory_general_cancel",
    ],
  },
  {
    path: "/inventory/movements",
    nav: false,
    label: "Movimientos",
    element: stockMovementsElement,
    requiredAnyPerms: ["inventory_movement_view"],
  },
  {
    path: "/cash/registers",
    nav: false,
    element: cashRegistersElement,
    requiredAnyPerms: ["cash_register_view", "cash_register_manage"],
    sidebar: false,
  },
  {
    path: "/cash/session",
    nav: false,
    label: "Mi caja",
    element: cashierCashSessionElement,
    requiredPerms: ["cash_view"],
    requiresCashierQueue: true,
    sidebar: false,
  },
  {
    path: "/cash/sessions",
    nav: false,
    element: <Navigate to="/cash/session" replace />,
    sidebar: false,
  },
  {
    path: "/cash/sessions/:id",
    nav: false,
    element: <Navigate to="/admin/cash" replace />,
    sidebar: false,
  },
  {
    path: "/app/profile",
    nav: false,
    label: "Mi perfil",
    icon: <AccountCircleOutlined fontSize="small" />,
    element: profileElement,
    sidebar: false,
  },
  {
    path: "/app/*",
    element: <div>TODO rutas modulos</div>,
    requiredPerms: [],
  },
];

export const sidebarAdminSections = [];

export const sidebarBusinessSections = [
  {
    id: "sales",
    title: "Ventas",
    nav: true,
    icon: <SellOutlined fontSize="small" />,
    items: [
      {
        id: "sales-main",
        label: "Nueva venta",
        nav: true,
        path: "/sales",
        icon: <SellOutlined fontSize="small" />,
        salesDraftAction: "new",
        requiredAnyPerms: ["sale_create"],
      },
      {
        id: "sales-history",
        label: "Historial de ventas",
        nav: true,
        path: "/sales/history",
        icon: <HistoryOutlined fontSize="small" />,
        requiredAnyPerms: ["view_sales", "sale_void", "sales_return_view", "sales_return_create"],
      },
    ],
  },
  {
    id: "customers",
    title: "Clientes",
    nav: true,
    icon: <PeopleOutlined fontSize="small" />,
    items: [
      {
        id: "customers-list",
        label: "Clientes",
        nav: true,
        path: "/customers",
        icon: <PeopleOutlined fontSize="small" />,
        requiredAnyPerms: ["sale_create", "view_sales"],
      },
      {
        id: "customers-create",
        label: "Nuevo cliente",
        nav: true,
        path: "/customers/create",
        icon: <PersonAddAlt1Outlined fontSize="small" />,
        requiredAnyPerms: ["sale_create"],
      },
    ],
  },
  {
    id: "invoice",
    title: "Facturación",
    nav: true,
    icon: <ReceiptLongOutlined fontSize="small" />,
    requiredAnyPerms: [
      "billing_view",
      "billing_create",
      "billing_manage",
      "billing_deferred_view",
      "billing_deferred_create",
    ],
    requiresBilling: true,
    items: [
      {
        id: "invoice-pending",
        label: "Pendientes",
        nav: true,
        path: "/invoice/pending",
        icon: <ReceiptLongOutlined fontSize="small" />,
        requiredAnyPerms: ["billing_deferred_view", "billing_deferred_create"],
        requiresBilling: true,
        requiresDeferredBilling: true,
      },
      {
        id: "invoice-documents",
        label: "Facturas internas",
        nav: true,
        path: "/invoice/documents",
        icon: <ReceiptLongOutlined fontSize="small" />,
        requiredAnyPerms: ["billing_view", "billing_create", "billing_manage"],
        requiresBilling: true,
      },
    ],
  },
  {
    id: "products",
    title: "Productos",
    nav: true,
    icon: <Inventory2Outlined fontSize="small" />,
    items: [
      {
        id: "products-list",
        label: "Lista de productos",
        nav: true,
        path: "/products",
        icon: <Inventory2Outlined fontSize="small" />,
        requiredAnyPerms: ["view_products", "manage_products"],
      },
      {
        id: "products-create",
        label: "Crear producto",
        nav: true,
        path: "/products/create",
        icon: <LocalOfferOutlined fontSize="small" />,
        requiredAnyPerms: ["manage_products"],
      },
    ],
  },
  {
    id: "cash",
    title: "Caja",
    nav: true,
    icon: <PointOfSaleOutlined fontSize="small" />,
    items: [
      {
        id: "cashbox-main",
        label: "Caja",
        nav: true,
        path: "/cashbox",
        icon: <PointOfSaleOutlined fontSize="small" />,
        requiredPerms: ["cash_view"],
        requiresCashierQueue: true,
      },
      {
        id: "cash-session",
        label: "Mi caja",
        nav: true,
        path: "/cash/session",
        icon: <PointOfSaleOutlined fontSize="small" />,
        requiredPerms: ["cash_view"],
        requiresCashierQueue: true,
      },
      {
        id: "admin-cash-sessions",
        label: "Cuadres de caja",
        nav: true,
        path: "/admin/cash",
        icon: <HistoryOutlined fontSize="small" />,
        requiredAnyPerms: ["cash_session_view", "cash_session_manage"],
      },
      {
        id: "cash-registers",
        label: "Cajas",
        nav: true,
        path: "/cash/registers",
        icon: <PointOfSaleOutlined fontSize="small" />,
        requiredAnyPerms: ["cash_register_view", "cash_register_manage"],
      },
    ],
  },
  {
    id: "grooming",
    title: "Grooming",
    nav: true,
    icon: <ContentCutOutlined fontSize="small" />,
    items: [
      {
        id: "grooming-reception",
        label: "Recepcion",
        nav: true,
        path: "/grooming/reception",
        icon: <PetsOutlined fontSize="small" />,
        requiredAnyPerms: ["grooming_view"],
      },
      {
        id: "grooming-appointments",
        label: "Agenda",
        nav: true,
        path: "/grooming/appointments",
        icon: <EventOutlined fontSize="small" />,
        requiredAnyPerms: ["grooming_view"],
      },
      {
        id: "grooming-orders",
        label: "Ordenes",
        nav: true,
        path: "/grooming/orders",
        icon: <ContentCutOutlined fontSize="small" />,
        requiredAnyPerms: ["grooming_view"],
      },
    ],
  },
  {
    id: "inventory",
    title: "Inventario",
    nav: true,
    icon: <InventoryOutlined fontSize="small" />,
    items: [
      {
        id: "inventory-stocks",
        label: "Existencias",
        nav: true,
        path: "/inventory/stocks",
        icon: <Inventory2Outlined fontSize="small" />,
        requiredAnyPerms: ["inventory_stock_view"],
      },
      {
        id: "inventory-movements",
        label: "Movimientos",
        nav: true,
        path: "/inventory/movements",
        icon: <TimelineOutlined fontSize="small" />,
        requiredAnyPerms: ["inventory_movement_view"],
      },
      {
        id: "counts-selective",
        label: "Selectivos",
        nav: true,
        path: "/inventory/counts/selective",
        icon: <PlaylistAddCheckOutlined fontSize="small" />,
        requiredAnyPerms: SELECTIVE_INVENTORY_PERMISSIONS,
      },
      {
        id: "counts-general",
        label: "Inventario general",
        nav: true,
        path: "/inventory/counts/general",
        icon: <Inventory2Outlined fontSize="small" />,
        requiredAnyPerms: GENERAL_INVENTORY_PERMISSIONS,
      },
    ],
  },
  {
    id: "supply",
    title: "Abastecimiento",
    nav: true,
    icon: <LocalShippingOutlined fontSize="small" />,
    items: [
      {
        id: "inventory-inbound-notes",
        label: "Notas de entrada",
        nav: true,
        path: "/inventory/inbound-notes",
        icon: <LocalShippingOutlined fontSize="small" />,
        requiredAnyPerms: ["inventory_inbound_view", "inventory_inbound_create"],
      },
      {
        id: "inventory-outbound-notes",
        label: "Notas de salida",
        nav: true,
        path: "/inventory/outbound-notes",
        icon: <DriveFileMove fontSize="small" />,
        requiredAnyPerms: ["inventory_outbound_view", "inventory_outbound_create", "inventory_outbound_approve"],
      },
    ],
  },
  {
    id: "reports",
    title: "Reportes",
    nav: true,
    icon: <AssessmentOutlined fontSize="small" />,
    items: [
      {
        id: "reports-products-profit",
        label: "Por producto",
        nav: true,
        path: "/reports/products-profit",
        icon: <AssessmentOutlined fontSize="small" />,
        requiredAnyPerms: ["view_reports"],
      },
      {
        id: "reports-sales-profit",
        label: "Utilidad ventas",
        nav: true,
        path: "/reports/sales-profit",
        icon: <AssessmentOutlined fontSize="small" />,
        requiredAnyPerms: ["view_reports"],
      },
      {
        id: "reports-sales-by-date",
        label: "Ventas por fecha",
        nav: true,
        path: "/reports/sales-by-date",
        icon: <AssessmentOutlined fontSize="small" />,
        requiredAnyPerms: ["view_reports"],
      },
    ],
  },
  {
    id: "settings-catalogs",
    title: "Configuracion: Catalogos",
    nav: true,
    icon: <CategoryOutlined fontSize="small" />,
    items: [
      {
        id: "settings-categories",
        label: "Categorias",
        nav: true,
        path: "/settings/categories",
        icon: <CategoryOutlined fontSize="small" />,
        requiredAnyPerms: ["view_categories", "manage_categories"],
      },
      {
        id: "settings-formats",
        label: "Formatos",
        nav: true,
        path: "/settings/formats",
        icon: <PrecisionManufacturingOutlined fontSize="small" />,
        requiredAnyPerms: ["view_formats", "manage_formats"],
      },
      {
        id: "settings-brands",
        label: "Marcas",
        nav: true,
        path: "/settings/brands",
        icon: <LocalOfferOutlined fontSize="small" />,
        requiredAnyPerms: ["view_brands", "manage_brands"],
      },
      {
        id: "settings-families",
        label: "Familias",
        nav: true,
        path: "/settings/families",
        icon: <MiscellaneousServicesOutlined fontSize="small" />,
        requiredAnyPerms: ["view_families", "manage_families"],
      },
    ],
  },
  {
    id: "settings-security",
    title: "Configuracion: Seguridad",
    nav: true,
    icon: <SecurityOutlined fontSize="small" />,
    items: [
      {
        id: "settings-security-users",
        label: "Usuarios",
        nav: true,
        path: "/admin/users",
        icon: <ManageAccountsOutlined fontSize="small" />,
        requiredAnyPerms: ["view_users", "manage_users"],
      },
      {
        id: "settings-security-roles",
        label: "Roles",
        nav: true,
        path: "/admin/roles",
        icon: <ShieldOutlined fontSize="small" />,
        requiredAnyPerms: ["view_roles", "manage_roles"],
      },
      {
        id: "settings-security-invites",
        label: "Invitaciones",
        nav: true,
        path: "/admin/invites",
        icon: <LinkOutlined fontSize="small" />,
        requiredAnyPerms: ["manage_users"],
      },
      {
        id: "settings-security-permissions",
        label: "Guia de permisos",
        nav: true,
        path: "/admin/permissions",
        icon: <SecurityOutlined fontSize="small" />,
        requiredAnyPerms: ["view_permissions", "manage_permissions"],
      },
    ],
  },
  {
    id: "settings-admin",
    title: "Configuracion: Administracion",
    nav: true,
    icon: <SettingsSuggestOutlined fontSize="small" />,
    items: [
      {
        id: "admin-companies",
        label: "Sucursales",
        nav: true,
        path: "/admin/companies",
        icon: <ApartmentOutlined fontSize="small" />,
        superuserOnly: true,
      },
      {
        id: "admin-company-bank-accounts",
        label: "Cuentas bancarias",
        nav: true,
        path: "/admin/company-bank-accounts",
        icon: <AccountBalanceOutlined fontSize="small" />,
        requiredAnyPerms: ["sale_manage_transfer_accounts"],
      },
      {
        id: "settings-sales-config",
        label: "Configuracion de ventas",
        nav: true,
        path: "/settings/sales",
        icon: <SettingsSuggestOutlined fontSize="small" />,
        requiredAnyPerms: ["manage_sales", "sale_manage_transfer_accounts", "cash_session_manage", "billing_manage"],
      },
      {
        id: "settings-count-settings",
        label: "Ajustes de conteo",
        nav: true,
        path: "/admin/count-settings",
        icon: <PlaylistAddCheckOutlined fontSize="small" />,
        requiredAnyPerms: ["inventory_count_settings_manage"],
      },
      {
        id: "settings-grooming-config",
        label: "Configuracion grooming",
        nav: true,
        path: "/grooming/config",
        icon: <SettingsSuggestOutlined fontSize="small" />,
        requiredAnyPerms: ["grooming_settings_manage"],
      },
      {
        id: "settings-grooming-service-types",
        label: "Tipos de servicio grooming",
        nav: true,
        path: "/grooming/service-types",
        icon: <ContentCutOutlined fontSize="small" />,
        requiredAnyPerms: ["grooming_settings_manage"],
      },
    ],
  },
];
